import React, { useState, useEffect } from "react";
import { Header } from "../../components/ui/Header";
import Typograpy from "../../components/ui/Typography";
import { forwardRef } from "react";
import MaterialTable from "material-table";

import {
  callRatesApi,
  getIBRRate,
  getMargin,
  updateFee,
  updateMargin,
} from "../../services/margin";
import TextField from "../../components/ui/TextField";
import Button from "../../components/ui/Button";
import {
  SortArrowIcon,
  EditIcon,
  TableRightArrowIcon,
  TablePrevIcon,
  TableSearchIcon,
  CloseIcon,
  TableSaveIcon,
  TableFirstPageIcon,
  TableLastPageIcon,
  CircleXCloseMark,
} from "../../assets/Icons";
import { merge_object_arrays, currencySequence } from "../../utils";
import { Mixpanel } from "../../constants/mixpanel";

const tableIcons: any = {
  SortArrow: forwardRef((props, ref: any) => <SortArrowIcon {...props} ref={ref} />),
  Edit: forwardRef((props, ref: any) => <EditIcon {...props} ref={ref} />),
  NextPage: forwardRef((props, ref: any) => (
    <TableRightArrowIcon className="" {...props} ref={ref} />
  )),
  PreviousPage: forwardRef((props, ref: any) => (
    <TablePrevIcon className="" {...props} ref={ref} />
  )),
  Search: forwardRef((props, ref: any) => (
    <TableSearchIcon className="mt-1" {...props} ref={ref} />
  )),
  Clear: forwardRef((props, ref: any) => <CloseIcon className="mt-1" {...props} ref={ref} />),
  Check: forwardRef((props, ref: any) => <TableSaveIcon className="mt-1" {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref: any) => (
    <TableFirstPageIcon className="" {...props} ref={ref} />
  )),
  LastPage: forwardRef((props, ref: any) => (
    <TableLastPageIcon className="" {...props} ref={ref} />
  )),
};

const Margin = () => {
  const [purposeCode, setPurposeCode] = useState("marginValue");
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  const [customers, setCustomers] = useState([]);
  const [marginData, setMarginData] = useState();
  const [fxRates, setFxRates] = useState();
  const [fee, setFee] = useState();
  const [feeGift, setFeeGift] = useState();
  const [feeMaintenance, setFeeMaintenance] = useState();
  const [bankFee, setBankFee] = useState();
  const [bankFeeGift, setBankFeeGift] = useState();
  const [bankFeeMaintenance, setBankFeeMaintenance] = useState();
  const [nostro, setNostro] = useState();
  const [nostroGift, setNostroGift] = useState();
  const [nostroMaintenance, setNostroMaintenance] = useState();
  const [purposeCodeSend, setPurposeCodeSend] = useState("other");
  const [errMessage, setErrMessage] = useState("");

  const [bankFees, setBankFees] = useState();
  const [vendorFee, setVendorFee] = useState();
  const [nostroCharge, setNostroCharge] = useState();

  const [editable, setEditable] = useState(false);
  const [btnText, setBtnText] = useState("Edit");
  const [showCardRates, setShowCardRates] = useState(false);
  const [rateLoading, setRateLoading] = useState(false);
  const [newAdRate, setNewAdRate] = useState([]);

  const columns: any = [
    { title: "Currency", field: "currency", editable: "never", type: "string" as const },
    { title: "Bank Rate", field: "rate", editable: "never", type: "string" as const },
    {
      title: "Default Margin",
      field:
        purposeCode === "marginValue"
          ? "marginValue"
          : purposeCode === "marginValueGift"
          ? "marginValueGift"
          : "marginValueMaintanence",
      editable: "never",
      type: "string" as const,
    },
    {
      title: "Vendor Margin",
      field:
        purposeCode === "marginValue"
          ? "vendorMarginValue"
          : purposeCode === "marginValueGift"
          ? "vendorMarginValueGift"
          : "vendorMarginValueMaintenance",
      editable: "onUpdate",
      type: "string" as const,
    },
    {
      title: "K2 Rate",
      field: "currency",
      editable: "never",
      type: "string" as const,
      render: (rowData: any) => {
        const marginValue =
          purposeCode === "marginValue"
            ? rowData.marginValue
            : purposeCode === "marginValueGift"
            ? rowData.marginValueGift
            : rowData.marginValueMaintanence;
        const vendorMarginValue =
          purposeCode === "marginValue"
            ? rowData.vendorMarginValue
            : purposeCode === "marginValueGift"
            ? rowData.vendorMarginValueGift
            : rowData.vendorMarginValueMaintenance;
        const total = (
          parseFloat(rowData.rate) +
          parseFloat(marginValue) +
          parseFloat(vendorMarginValue)
        ).toFixed(4);
        return (
          <>
            <label>{total}</label>
          </>
        );
      },
    },
  ];

  const CardRateColumns: any = [
    { title: "Currency", field: "currency", editable: "never", type: "string" as const },
    { title: "AD1- Rate", field: "cardRateAd1", editable: "never", type: "string" as const },
    { title: "AD2- Rate", field: "cardRate", editable: "never", type: "string" as const },
  ];

  const handleUpdateMargin = (value: any) => {
    const marginValue = {
      currency: value["currency"],
      margin_value:
        purposeCode === "marginValue" && value["vendorMarginValue"]
          ? value["vendorMarginValue"]
          : purposeCode === "marginValueGift" && value["vendorMarginValueGift"]
          ? value["vendorMarginValueGift"]
          : purposeCode === "marginValueMaintanence" && value["vendorMarginValueMaintenance"]
          ? value["vendorMarginValueMaintenance"]
          : 0,
      vendor_key: currentUser.vendor_key,
      purpose: purposeCodeSend,
    };

    updateMargin(marginValue).then(() => {
      // window.location.reload();
      Mixpanel.track(`save_${value?.currency}_margin`);
      getMarginData();
    });
  };

  async function handleUpdateFee() {
    Mixpanel.track("Edit_margin");
    if (!editable) {
      setEditable(true);
      setBtnText("Update");
      return;
    }

    const feeData = {
      vendorBankFee: bankFees ? bankFees : 0,
      vendorConvenienceFee: vendorFee ? vendorFee : 0,
      vendorNostroCharge: nostroCharge ? nostroCharge : 0,
      vendor_key: currentUser.vendor_key,
      purpose: purposeCodeSend,
    };

    updateFee(feeData)
      .then(() => {
        setEditable(false);
        setErrMessage("");
        setBtnText("Edit");
        // window.location.reload();
      })
      .catch((err) => {
        setErrMessage(err?.response?.data?.error?.type);
      });
  }

  useEffect(() => {
    if (purposeCode && purposeCode === "marginValue") {
      setPurposeCodeSend("other");
    } else if (purposeCode && purposeCode === "marginValueGift") {
      setPurposeCodeSend("gift");
    } else if (purposeCode && purposeCode === "marginValueMaintanence") {
      setPurposeCodeSend("maintenance");
    }
  }, [purposeCode]);

  React.useEffect(() => {
    if (bankFee && purposeCode === "marginValue") {
      setBankFees(bankFee);
    } else if (bankFeeGift && purposeCode === "marginValueGift") {
      setBankFees(bankFeeGift);
    } else if (bankFeeMaintenance && purposeCode === "marginValueMaintanence") {
      setBankFees(bankFeeMaintenance);
    }

    if (fee && purposeCode === "marginValue") {
      setVendorFee(fee);
    } else if (feeGift && purposeCode === "marginValueGift") {
      setVendorFee(feeGift);
    } else if (feeMaintenance && purposeCode === "marginValueMaintanence") {
      setVendorFee(feeMaintenance);
    }

    if (nostro && purposeCode === "marginValue") {
      setNostroCharge(nostro);
    } else if (nostroGift && purposeCode === "marginValueGift") {
      setNostroCharge(nostroGift);
    } else if (nostroMaintenance && purposeCode === "marginValueMaintanence") {
      setNostroCharge(nostroMaintenance);
    }
  }, [fee, bankFee, nostro, purposeCode]);

  const getMarginData = () => {
    getMargin().then((res: any) => {
      const data = res.data.Margin_List;
      const fees = res.data.convenience_fee;
      const feesGift = res.data.convenience_fee_gift;
      const feesMaintenance = res.data.convenience_fee_maintenance;
      const bfees = res.data.bank_fee;
      const bfeesGift = res.data.bank_fee_gift;
      const bfeesMaintenance = res.data.bank_fee_maintenance;
      const nostroCharge = res.data.nostro_charge;
      const nostroChargeGift = res.data.nostro_charge_gift;
      const nostroChargeMaintenance = res.data.nostro_charge_maintenance;

      setMarginData(data);
      setFee(fees);
      setFeeGift(feesGift);
      setFeeMaintenance(feesMaintenance);
      setBankFee(bfees);
      setBankFeeGift(bfeesGift);
      setBankFeeMaintenance(bfeesMaintenance);
      setNostro(nostroCharge);
      setNostroGift(nostroChargeGift);
      setNostroMaintenance(nostroChargeMaintenance);
    });
  };

  const getIBRRateData = () => {
    getIBRRate(currentUser).then((res: any) => {
      const rates = res.data.rate;
      const fxRates: any = Object.keys(rates).map((item) => {
        return {
          [item]: rates[item],
          currency: `${item}`,
          rate: rates[item],
        };
      });
      setFxRates(fxRates);
    });
  };

  React.useEffect(() => {
    if (marginData && fxRates) {
      const newObject: any = merge_object_arrays(marginData, fxRates, "currency");

      newObject.sort(
        (a: any, b: any) =>
          currencySequence.indexOf(a.currency) - currencySequence.indexOf(b.currency),
      );
      setCustomers(newObject);
    }
  }, [fxRates, marginData]);

  React.useEffect(() => {
    getMarginData();
    getIBRRateData();
  }, []);

  const handleRadioChange = (e: any) => {
    setPurposeCode(e.target.value);
  };

  // const userToken = localStorage.getItem("userToken");
  // const validationKey = window.crypto.getRandomValues(new Uint32Array(1))[0].toString();

  const ratesApi = async () => {
    setRateLoading(true);
    try {
      const api = await callRatesApi();
      const response = await api?.data;
      if (response) {
        const rates = response?.cardRate;
        rates.sort(
          (a: any, b: any) =>
            currencySequence.indexOf(a.currency) - currencySequence.indexOf(b.currency),
        );
        setNewAdRate(rates);
      }
    } catch (error) {
      window.console.error("Error", error);
    } finally {
      setRateLoading(false);
    }
  };

  const handleCardRate = () => {
    setShowCardRates(!showCardRates);
    ratesApi();
  };

  const purposeCodes = ["marginValueGift", "marginValueMaintanence"];

  return (
    <div className="flex flex-col relative">
      <Header />
      {showCardRates && (
        <div className="flex z-[20] w-screen h-screen items-center justify-center absolute ">
          <div className="flex flex-col absolute md:w-[60%] md:h-fit opacity-100 shadow-lg bg-white rounded-md p-5">
            <div className="w-full">
              <div className="border-b-2 items-center border-gray-200 mt-2 w-full flex justify-between">
                <h2 className="text-black text-xl font-semibold">Card Rate</h2>
                <div className="cursor-pointer" onClick={() => setShowCardRates(!showCardRates)}>
                  <CircleXCloseMark />
                </div>
              </div>
            </div>
            <div className="mt-4 h-fit max-h-[480px] overflow-auto ">
              {rateLoading ? (
                <h2 className="text-black">Loading Card Rates...</h2>
              ) : (
                <MaterialTable
                  // title="Currency Margin Update"
                  columns={CardRateColumns}
                  data={newAdRate && newAdRate}
                  icons={tableIcons}
                  localization={{
                    header: {
                      actions: "",
                    },
                  }}
                  options={{
                    actionsColumnIndex: 0,
                    search: false,
                    toolbar: false,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}
      <div className="py-10 px-28">
        <div className="flex items-center justify-between mb-4">
          <Button
            bgColor="bg-primary"
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className={"py-4 px-14 cursor-pointer"}
            onClickHandler={() => {
              handleCardRate();
              Mixpanel.track("Card_rate");
            }}
          >
            Card Rates
          </Button>
          <div>
            <Typograpy tagType="div" className="mb-1 mr-6 font-medium">
              Select purpose code
            </Typograpy>
            <div className="flex items-center space-x-6">
              <span className="flex items-center space-x-3">
                <input
                  type="radio"
                  id="yes"
                  name="choose"
                  value="marginValue"
                  checked={purposeCode === "marginValue"}
                  onChange={handleRadioChange}
                  className="w-4 h-4 cursor-pointer"
                />
                <label htmlFor="Other">Other</label>
              </span>
              <span className="flex items-center space-x-3">
                <input
                  type="radio"
                  id="no"
                  name="choose"
                  value="marginValueGift"
                  onChange={handleRadioChange}
                  checked={purposeCode === "marginValueGift"}
                  className="w-4 h-4 cursor-pointer"
                />
                <label htmlFor="Gift">Gift</label>
              </span>
              <span className="flex items-center space-x-3">
                <input
                  type="radio"
                  id="maybe"
                  name="choose"
                  value="marginValueMaintanence"
                  onChange={handleRadioChange}
                  checked={purposeCode === "marginValueMaintanence"}
                  className="w-4 h-4 cursor-pointer"
                />
                <label htmlFor="Maintenance">Maintenance</label>
              </span>
            </div>
          </div>
        </div>
        <div>
          <MaterialTable
            title="Currency Margin Update"
            columns={columns}
            data={customers && customers}
            icons={tableIcons}
            editable={{
              onRowUpdate: (newData: any) =>
                new Promise((resolve: any) => {
                  Mixpanel.track(`edit_${newData?.currency}_margin`);
                  setTimeout(() => {
                    handleUpdateMargin(newData);
                    resolve();
                  }, 1000);
                }),
            }}
            localization={{
              header: {
                actions: "",
              },
            }}
            options={{
              actionsColumnIndex: 0,
              search: false,
            }}
          />
        </div>
        {!purposeCodes?.includes(purposeCode) && (
          <div className="flex flex-col">
            <Typograpy tagType="div" className="my-2 font-bold">
              Fee and Charges
            </Typograpy>
            <div className="flex items-center justify-between">
              <div className="flex flex-col">
                <div className="flex items-center space-x-8">
                  <TextField
                    disabled
                    name="bankFee"
                    value={bankFees}
                    placeholder="Bank Fees"
                    rootClassName=""
                    onChange={(event) => {
                      setBankFees(event.target.value);
                    }}
                    style={{ width: "30%" }}
                  />
                  <TextField
                    disabled
                    name="nostroCharge"
                    value={nostroCharge}
                    placeholder="Nostro Charge"
                    onChange={(event) => {
                      setNostroCharge(event.target.value);
                    }}
                    style={{ width: "30%" }}
                  />
                  <TextField
                    type="number"
                    disabled={btnText === "Edit" ? true : false}
                    name="vendorFee"
                    value={vendorFee}
                    placeholder="Vendor Fees"
                    onChange={(event) => {
                      setVendorFee(event.target.value);
                      setErrMessage('');
                    }}
                    className="w-1/3"
                    style={{ width: "30%" }}
                    maxLength={4}
                  />
                </div>
                <div className="flex justify-end text-error">
                  {errMessage && <span className="mt-1 text-xs">{errMessage}</span>}
                </div>
              </div>

              <Button
                bgColor="bg-primary"
                fontStyle={{
                  fontFamily: "font-ssp",
                  fontSize: "text-base",
                  fontWeight: "font-bold",
                  fontColor: "text-white",
                }}
                borderStyle={{
                  borderRadius: "rounded",
                }}
                className={errMessage ? "py-4 px-14 mb-[-28px]" : "py-4 px-14"}
                onClickHandler={handleUpdateFee}
              >
                {btnText}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Margin;